import { render, staticRenderFns } from "./StandardForm.vue?vue&type=template&id=3acb7146&"
import script from "./StandardForm.vue?vue&type=script&lang=js&"
export * from "./StandardForm.vue?vue&type=script&lang=js&"
import style0 from "./StandardForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports